import { render, staticRenderFns } from "./gap.vue?vue&type=template&id=0da159f8&scoped=true&"
import script from "./gap.vue?vue&type=script&lang=js&"
export * from "./gap.vue?vue&type=script&lang=js&"
import style0 from "./gap.vue?vue&type=style&index=0&id=0da159f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da159f8",
  null
  
)

export default component.exports